import type { FacetChipsProps } from './FacetChips.types';

/**
 * A row of clickable chips that narrow the listing by one array-valued facet.
 *
 * Empty renders as a plain marker rather than nothing: an absent value is
 * meaningful here (no RAG search happened, or the classification event was
 * dropped) and a blank cell would read as a rendering bug.
 */
export const FacetChips = ({ values, label, chipClassName, title, emptyLabel, onSelect }: FacetChipsProps) => {
	if (!values.length) return <span className="text-[11px] text-subtle">{emptyLabel}</span>;

	return (
		<div className="flex flex-wrap gap-3xs">
			{values.map((value) => (
				<button
					key={value}
					type="button"
					// `relative` lifts the chip above the row's full-cell link overlay;
					// without it the anchor swallows the click and nothing filters.
					className={`relative ${typeof chipClassName === 'function' ? chipClassName(value) : chipClassName}`}
					onClick={() => onSelect(value)}
					title={title(value)}
				>
					{label(value)}
				</button>
			))}
		</div>
	);
};
